// extracted by mini-css-extract-plugin
export default {"text":"IconCard_text__Qz0wc","card":"IconCard_card__BxHHN","cardContent":"IconCard_cardContent__-Y+ZQ","iconWrap":"IconCard_iconWrap__AY254"};